import type { ReactNode } from 'react';
import { NavLink } from 'react-router';
import type { NavTab } from '../nav';

/**
 * Tabs across the top of a page that has more than one screen (D-325), such as
 * Staff and its pending logins, or Settings and its branding and terms. Each
 * tab is still its own route, so a shared link to one opens that tab.
 */
export function SectionTabs({ tabs, children }: { tabs: readonly NavTab[]; children: ReactNode }) {
  return (
    <div className="space-y-4">
      <nav aria-label="Sections" className="flex gap-1 border-b border-line">
        {tabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end
            className={({ isActive }) =>
              `-mb-px border-b-2 px-3 py-2 text-sm font-medium ${isActive ? 'border-brand text-ink' : 'border-transparent text-ink-500 hover:text-ink'}`
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
      {children}
    </div>
  );
}
